import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, UploadCloud } from "lucide-react";

export default function ResumeModal({ open, onClose }) {
  const [uploading, setUploading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    setSuccess(false);

    try {
      const formData = new FormData();
      formData.append("resume", file);

      const res = await fetch(
        "https://71qn1r63pe.execute-api.ap-south-1.amazonaws.com/resume",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!res.ok) {
        throw new Error("Upload failed");
      }

      setSuccess(true);
    } catch (error) {
      console.error("Upload error:", error);
      alert("Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ type: "spring", stiffness: 160, damping: 20 }}
            className="relative bg-white/80 backdrop-blur-xl p-10 rounded-3xl shadow-2xl max-w-lg w-full text-center border border-white/40"
          >
            {/* Close Button */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-600 hover:text-black"
            >
              <X size={26} />
            </button>

            {/* Heading */}
            <h2 className="text-3xl font-bold text-gray-800 mb-3">
              Ready to Grow Your Career?
            </h2>
            <p className="text-gray-600 mb-6">
              Upload your resume and let Talent Squeed help you find the perfect
              opportunity. Your next big move starts here!
            </p>

            {/* Upload Box */}
            <label className="border-2 border-dashed border-cyan-500/60 rounded-xl p-8 cursor-pointer hover:bg-cyan-50 transition block">
              <div className="flex flex-col items-center">
                <UploadCloud size={50} className="text-cyan-600 mb-3" />
                <p className="font-medium text-gray-700 mb-1">
                  {uploading ? "Uploading..." : "Click to upload"}
                </p>
                <p className="text-sm text-gray-500">PDF, DOC — max 5MB</p>

                {success && (
                  <p className="text-green-600 font-semibold mt-3">
                    ✔ Resume Uploaded Successfully
                  </p>
                )}
              </div>

              <input
                type="file"
                accept=".pdf,.doc,.docx"
                className="hidden"
                onChange={handleFileUpload}
              />
            </label>

            {/* Divider */}
            <div className="my-6 flex items-center">
              <span className="flex-grow border-t border-gray-300"></span>
              <span className="px-4 text-gray-400 text-sm">or</span>
              <span className="flex-grow border-t border-gray-300"></span>
            </div>

            {/* Email Option */}
            <p className="text-gray-600 text-sm">
              Send your resume to{" "}
              <span className="text-cyan-600 font-semibold">
                info@talentsqueed.in
              </span>
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
